module.exports = __webpack_public_path__ + "media/hph-24-05_commencement.ee2033ef.mp4";